<template>
  <RouterLink
    :to="`/blog/${post.fields.slug}`"
    class="sm:px-2 w-full sm:w-6/12 md:w-4/12 mb-8 sm:mb-4 self-stretch block"
  >
    <div class="hover:shadow cursor-pointer sm:rounded flex flex-col h-full" :class="[shadow, bgWhite ? 'bg-white' : 'bg-background ']">
      <div class="media bg-gray relative cursor-pointer sm:rounded-t">
        <div class="absolute top-0 left-0 h-full w-full overflow-hidden">
          <UtilImage
            v-if="post.fields.attachment"
            :src="`${post.fields.attachment.fields.file.url}?w=500&fm=jpg&fl=progressive&q=75`"
            cover
            :roundedTop="$breakpoint.smAndUp || undefined"
            :alt="post.fields.title"
            class="h-full"
            targetClass="rounded-b-none"
          >
            <template #loading>
              <UtilPlaceholder class="absolute top-0 left-0 h-full w-full" />
            </template>
          </UtilImage>
        </div>
      </div>

      <div class="flex flex-col flex-grow py-6 px-4">
        <h3 class="font-bold text-lg clamp-2">{{ post.fields.title }}</h3>
        
        <p class="text-sm font-medium pt-2">
          {{ $date(post.fields.created_at).format('LL') }}
        </p>

        <p class="pt-2 font-thin text-sm leading-relaxed">
          {{ post.fields.excerpt ? post.fields.excerpt : post.fields.content.substring(0, 50) }}
        </p>
        
        <p class="text-sm font-medium pt-4 flex-grow flex content-end items-end">
          <span>
            <span class="mr-1">Read more</span>
            <FontAwesomeIcon :icon="faChevronRight" />
          </span>
        </p>
      </div>
    </div>
  </RouterLink>
</template>

<script>
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'
import UtilImage from '@/components/utils/UtilImage'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'UtilBlogPostCard',
  components: {
    UtilPlaceholder,
    UtilImage
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    shadow: Boolean,
    bgWhite: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      faChevronRight
    }
  }
}
</script>

<style lang="scss" scoped>
.media {
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}
</style>
